import { render, staticRenderFns } from "./cova-import-wizard.vue?vue&type=template&id=212bea8d&scoped=true"
import script from "./cova-import-wizard.vue?vue&type=script&lang=js"
export * from "./cova-import-wizard.vue?vue&type=script&lang=js"
import style0 from "./cova-import-wizard.vue?vue&type=style&index=0&id=212bea8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212bea8d",
  null
  
)

export default component.exports